import React, { Fragment, useState, useEffect } from "react";
import Select from 'react-select'

const SearchableSelect = ({
    required = false,
    dataArray = [],
    selectLabel,
    label = "label",
    optionsValue = "value",
    className,
    register,
    name,
    errors = {},
    actions = [],
    onChange,
    undefinedValue = false,
    modifieValue = false,
    disabled,
    defaultValue = '',
    placeholder,
    value = ''
}) => {
    const labelText = required ? (
        <Fragment>
            {selectLabel}
            <span className={"text-danger"}>*</span>
        </Fragment>
    ) : (
        selectLabel
    );
    let isDisable = (disabled && disabled === true) ? true : false;
    return (
        <div className={`te-select ${className}`}>
            {selectLabel && labelText}
            <div className={"te-select-wrapper"}>


                <Select

                    name={name}
                    placeholder={placeholder ? placeholder : isDisable ? '-' : 'Select'}
                    isDisabled={isDisable}
                    onChange={(e, action) => {
                        onChange(e)

                    }}
                    classNamePrefix="multi-select-container"
                    className="multidropdown-container"
                    menuPlacement="auto"

                    options={dataArray}

                    selected={defaultValue}
                    value={value}

                />
            </div>
            {errors.hasOwnProperty(name) && (
                <small className="error-text">
                    {errors[name].message
                        ? errors[name].message
                        : "This field is required"}
                </small>
            )}
        </div>
    );
};

export default SearchableSelect;
